/**
 * Parse an operator-supplied flat string map — the shape both realm secrets and
 * BYOK credentials use (e.g. `{"api_key": "..."}`).
 *
 * Kept a standalone throwing function rather than inline form state so it is
 * unit-testable, and so every caller rejects the same malformed input with the
 * same actionable message instead of sending a body the server will refuse.
 */
export function parseStringMap(raw: string): Record<string, string> {
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    throw new Error("Not valid JSON.");
  }
  if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
    throw new Error('Expected a JSON object, e.g. {"api_key": "..."}.');
  }
  const entries = Object.entries(parsed as Record<string, unknown>);
  if (entries.length === 0) {
    throw new Error("Provide at least one key/value pair.");
  }
  if (!entries.every(([, v]) => typeof v === "string")) {
    throw new Error("All values must be strings.");
  }
  return Object.fromEntries(entries) as Record<string, string>;
}
